import {
  subscriptionApiKeys,
  useSubscriptionApi,
} from '@hooks/api/account/useSubscriptionApi';
import { useGetApi } from '@hooks/api/useGetApi';
import type { ActiveSubscriptionResponse } from 'types/account/subscriptions';
import type { GetApiOptions } from 'types/api';

export function useGetActiveSubscriptions(
  organizationId: string,
  {
    enabled = true,
    ...options
  }: Partial<GetApiOptions<ActiveSubscriptionResponse, Error>> = {}
) {
  const api = useSubscriptionApi();

  const { data, ...result } = useGetApi({
    enabled: !!organizationId && enabled,
    queryKey: subscriptionApiKeys.getActiveSubscriptions(organizationId),
    request: () => api.getActiveSubscriptions(organizationId),
    ...options,
  });

  return {
    ...result,
    activeSubscriptions: data?.subscriptions ?? [],
    activeSubscriptionsFrequency: data?.subscriptions?.[0]?.frequency,
    defaultPaymentMethod: data?.defaultPaymentMethod,
  };
}
